import { Routes } from '@angular/router';
import { fmaAuthGuard } from './oauth/fma-auth.guard';
import { consentTermGuard } from './guards/consent-term.guard';

export const routes: Routes = [
  {
    path: 'vehicle-status',
    loadComponent: () => import('./feature/vehicle-status-page/vehicle-status-page.component'),
    canActivate: [fmaAuthGuard()],
  },
  {
    path: '',
    loadComponent: () => import('./feature/select-application/select-application.component'),
  },
  {
    path: 'select-location',
    loadComponent: () => import('./feature/select-location/select-location.component'),
  },
  {
    path: 'digital-consent',
    loadComponent: () => import('./feature/digital-consent/digital-consent.component'),
    canActivate: [fmaAuthGuard()],
  },
  {
    path: 'consent-term/:id',
    loadComponent: () => import('./feature/consent-term/consent-term.component'),
    canActivate: [consentTermGuard],
  },
  {
    path: 'consent-term',
    loadComponent: () => import('./feature/consent-term/consent-term.component'),
  },
  {
    path: 'consent-term-desktop/:id',
    loadComponent: () => import('./feature/consent-term-desktop/consent-term-desktop.component'),
    canActivate: [consentTermGuard],
  },
  {
    path: 'consent-term-desktop',
    loadComponent: () => import('./feature/consent-term-desktop/consent-term-desktop.component'),
  },
  {
    path: 'not-found',
    loadComponent: () => import('./feature/not-found/not-found.component'),
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];
